import { ActivateSettings } from "@/type/core/transaction/transaction.types";
import { createStore } from "effector";
import { requestGetTransactionSettings } from "@state/transactions/TransactionEffects";

const initialState = null;

export const transactionSettingsStore = createStore<ActivateSettings | null>(
  initialState,
).on(requestGetTransactionSettings.doneData, (_, payload) => {
  return payload?.data;
});
